import { render } from "./app-form-select-custom-item.vue?vue&type=template&id=52b604ff"
import script from "./app-form-select-custom-item.vue?vue&type=script&lang=js"
export * from "./app-form-select-custom-item.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/app-form-select-custom-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52b604ff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52b604ff', __exports__)) {
    console.log('reload')
    api.reload('52b604ff', __exports__)
  }
  
  module.hot.accept("./app-form-select-custom-item.vue?vue&type=template&id=52b604ff", () => {
    console.log('re-render')
    api.rerender('52b604ff', render)
  })

}


export default __exports__